// extracted by mini-css-extract-plugin
export default {"Emoji":"bbb_a bhc_i bhc_q bhc_j"};